export default "__VITE_ASSET__QVYrnVmj__"